import React from 'react';
import AppHeader from '../../../../components/Header/Header';
import AppFooter from '../../../../components/Footer/footer';
import SidebarMenu from '../../../../components/SidebarMenu';
import BannerSection from '../../../../components/BannerSection';
import SectionHeading from '../../../../components/SectionHeading';
import BreadcrumbNav from '../../../../components/BreadcrumbNav';

const caminho = [
    { label: 'Home', href: '/', icon: 'bi bi-house-door' },
    { label: 'Programa' },
    { label: 'Unidade Orgânica', href: '/programas/unidade-organica' },
    { label: 'Ciências Econômicas Juridicas e Humanas' },
    { label: 'Missão, Visão e Valores' }
];


function Missao_visao_valoresCS() {
    return (
        <>
        <header id='header'>
        <AppHeader />
        </header>
        <BannerSection
            title="Missão, Visão e Valores"
            subtitle="Unidade Orgânica de Ciências Econômicas Juridicas e Humanas"
            description={`Conheça a missão, visão e valores que guiam a Unidade Orgânica de Ciências Econômicas Juridicas e Humanas, comprometida com a excelência na formação de profissionais de diversas áreas do conhecimento.`}
            backgroundImage={require('../../../../assets/img-heroUN.jpg')}
            backgroundId="instituition-Banner"
        />
        <BreadcrumbNav items={caminho} />
        <main className="px-3 px-md-5 px-xl-5 px-xxl-5 py-2">
        <br />
        <div className="row flex-row-reverse">
         <div className="col-12 col-md-4 col-lg-3 col-xl-2">
            <SidebarMenu
                title="Navegação"
                items={[
                { label: "Apresentação", href: "/programas/unidade-organica/ciencia-humanas" },
                { label: "Missão Visão e Valores", href: "/programas/unidade-organica/ciencia-humanas/missao-visao-valores" },
                ]}
            />
            </div>
        <div className="col-12 col-md-8 col-lg-9 col-xl-10 col-xxl-10">
                <br />
                <div style={{marginLeft:'50px'}} className="details-magazine">
                <p className="f-reg f-20" style={{ textAlign: "justify", marginRight: '50px', paddingRight: '50px' }}>
                <SectionHeading title="Nossa Missão" />
                <p className='f-reg f-20' style={{ textAlign: "justify", marginRight: '50px', paddingRight: '50px' }}>
                    Formar profissionais altamente qualificados nas áreas da Ciências Econômicas, Jurídicas e
                    Humanas, integrando saber científico, técnico e cultural, capazes de responder com ética,
                    inovação e responsabilidade social aos desafios do desenvolvimento econômico, jurídico e
                    humano da sociedade.
                    <br /><br />
                    A continuação da sua missão é orientada pela: 
                    <br /><br />
                    <ul>
                      <li><i className="fa-solid fa-check" style={{ color:'#00761f' }}></i> Produção de conhecimento, assente na excelência da investigação e da docência;</li>
                    <li><i className="fa-solid fa-check" style={{ color:'#00761f' }}></i> Disseminação do saber científico, através de uma oferta formativa distintiva e
                    integral, satisfazendo as necessidades de formação da sociedade e favorecendo
                    a inovação;
                    </li>
                    <li><i className="fa-solid fa-check" style={{ color:'#00761f' }}></i> Transferência do conhecimento em prol do desenvolvimento económico, tecnológico
                    e social, concorrendo para a melhoria da competitividade das empresas e da
                    qualidade de vida dos cidadãos.
                    </li>
                    </ul>
                    
                </p>

                </p>
                <br />
                <p className="f-reg f-20" style={{ textAlign: "justify", marginRight: '50px', paddingRight: '50px' }}>
                    <SectionHeading title="Nossos Valores" />
                    Comprometer-se com a educação e o conhecimento pautado nos seguintes valores: 
                    <br /> <br />
                    <ul>
                       <li><b style={{ color:'#00761F'}}>Qualidade e excelência:</b> esforçar-se para os mais altos padrões, conforme
                    comparado e avaliado pelos pares;
                    </li>
                    <li><b style={{ color:'#00761F'}}>Responsabilidade:</b> Compromisso com o bom uso e responsável dos recursos
                    humanos, fiscais e físicos que nos são confiados e actualizados;
                    </li>
                    <li><b style={{ color:'#00761F'}}>Transparência:</b> abertura ao escrutínio público sobre nossas acções, processos e uso
                    de nossos recursos; 
                    </li>
                    <li><b style={{ color:'#00761F'}}>Diversidade:</b> Reconhecer que a diversidade e a excelência são mutuamente
                    inclusivas, melhorando o nosso ensino, a erudição e o envolvimento da comunidade,
                    bem como a nossa capacidade de interagir com todas as pessoas;
                    </li>
                    <li><b style={{ color:'#00761F'}}>Integridade:</b> consistentemente abraçando e praticando honestidade, verdade e
                    liberdade em tudo o que fazemos; </li>
                    <li><b style={{ color:'#00761F'}}>Respeito:</b> Tratando todas as partes interessadas com civilidade e dignidade,
                    incluindo o respeito a identidade e a diversidade;</li>
                    <li><b style={{ color:'#00761F'}}>Responsabilidade social, envolvimento da comunidade:</b> Compromisso social
                    contribuindo da melhor forma possível para o bem-estar intelectual, social e
                    económico das comunidades que servimos;
                    </li>
                    <li><b style={{ color:'#00761F'}}>Autonomia Intelectual:</b> Proporcionar um ambiente de criatividade e inovação,
                    criando espaço para a implementação de linhas de pesquisas;</li>
                    <li><b style={{ color:'#00761F'}}>Integridade Científica:</b> O ensino e a investigação devem ser caracterizados por
                    independência intelectual e moral; </li>
                    <li><b style={{ color:'#00761F'}}>Diversidade Científica:</b> Promover uma consciência global que valorize a
                    investigação científica, promovendo projectos e linhas de pesquisas relevantes para
                    a comunidade onde está inserida e a sociedade em geral;</li>
                    <li>
                    <b style={{ color:'#00761F'}}>Excelência na Investigação:</b> Prosseguir os mais elevados standards de ensino e
                    investigação, com base num modelo de gestão orientado para uma cultura de
                    qualidade investigativa total e do mérito científico; 
                    </li>
                    <li><b style={{ color:'#00761F'}}>Comprometimento científico:</b> Fomentar a consciência colectiva de compromisso com
                    a investigação científica nas suas diferentes dimensões (social, ambiental, cultural,
                    económica, etc);
                    </li>
                    <li>
                      Aprendizagem para a Vida científica: Promover a busca do conhecimento científico
                      como forma de melhorar o bem-estar social e fortalecer a compreensão do
                      indivíduo, extravasando as fronteiras geográficas;
                    </li>
                    <li>
                    Cooperação: Abrir-se ao mundo académico através de convénios com as instituições
                    de notável reconhecimento ao nível mundial na vertente de ensino e investigação
                    científica. 
                    </li>
                    <li>
                    Rigor: Rigidez na organização, planificação e acompanhamento ou monitoramento
                    dos trabalhos prestados. 
                    </li>
                    </ul>
                </p>
                <br />
                <p className="f-reg f-20" style={{ textAlign: "justify", marginRight: '50px', paddingRight: '50px' }}>
                    <SectionHeading title="Nossa Visão" />
                    <ul>
                    <li><i className="fa-solid fa-check" style={{ color:'#00761f' }}></i> Ser uma referência nacional na formação de profissionais altamente capacitados e
                    especializados nas áreas de Gestão de Empresa, Gestão de Recursos Humanos,
                    Gestão de Contabilidade, Economia, Psicologia, Direito, Relações Internacionais,
                    Sociologia e demais áreas afins;
                    </li>
                    <br />
                    <li><i className="fa-solid fa-check" style={{ color:'#00761f' }}></i> Realizar a formação em estreita ligação com a investigação científica orientada
                    para solução dos problemas de acordo as épocas e situações e inserida no quadro
                    do conhecimento da ciência, da técnica e da tecnologia; 
                    </li>
                    <br />
                    <li><i className="fa-solid fa-check" style={{ color:'#00761f' }}></i> Promover a pesquisa e desenvolvimento tecnológico, impulsionando a inovação e a
                    descoberta de novas soluções para os desafios do país; 
                    </li>
                    <br />
                    <li><i className="fa-solid fa-check" style={{ color:'#00761f' }}></i> Valorizar a responsabilidade social e a ética profissional, buscando a
                    sustentabilidade ambiental, a inclusão social e a promoção do bem-estar da
                    comunidade;
                    </li>
                    <br />
                    <li><i className="fa-solid fa-check" style={{ color:'#00761f' }}></i> Realizar a formação em estreita ligação com a investigação científica orientada
                    para solução dos problemas de acordo as épocas e situações e inserida no quadro
                    do conhecimento da ciência, da técnica e da tecnologia; 
                    </li>
                    <br />
                    <li> <i className="fa-solid fa-check" style={{ color:'#00761f' }}></i> Preparar e assegurar o exercício da reflexão critica e da participação na
                    produção; 
                    </li>
                    <br />
                    <li> <i className="fa-solid fa-check" style={{ color:'#00761f' }}></i> Contribuir activamente para o desenvolvimento socioeconómico da região,
                    fornecendo serviços de consultoria e prestação de serviços no âmbito
                    sócioeconómico;
                    </li>
                    <br />
                    <li> <i className="fa-solid fa-check" style={{ color:'#00761f' }}></i> Ser reconhecida como uma unidade de excelência, formadora de profissionais
                    líderes e inovadores, que contribuam para o desenvolvimento sustentável do país;
                    </li>
                    <br />
                    <li><i className="fa-solid fa-check" style={{ color:'#00761f' }}></i> Realizar cursos de graduação (Licenciatura) e pós-graduação (Mestrados e
                    Doutoramentos) ou especialização para a superação científica e técnica dos
                    quadros de alto nível superior.
                    </li>
                    </ul>
                </p>
                <br />
                </div>
                <br /><br />
            </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        </main>
        <footer id="footer">
        <AppFooter />
      </footer>
        </>
    );
}

export default Missao_visao_valoresCS;